import { SPECIALALPHANUMERIC } from './../../../../Components/Forms/constant_form';

export const formFields = [
	{
		forms: [
      {
				label: 'Name',
				placeholder: 'Type position name',
				type: 'text',
				col: 'col-12',
				required: true,
				validate: {
					type: SPECIALALPHANUMERIC
				},
				name: 'name'
			}
		]

	}

];
